import type { Quizrun } from "@/types/domain";

/**
 * Small uppercase pill next to a quizrun title marking it Regular vs Special.
 * Special reads with extra weight (amber, bordered, semibold); Regular is
 * intentionally muted so specials stand out.
 */
export const KindBadge = ({ kind }: { kind?: Quizrun["kind"] | null }) => {
  const isSpecial = kind === "special";
  const className = isSpecial
    ? "border-amber-300/60 bg-amber-100 text-amber-700 font-semibold dark:border-amber-800/40 dark:bg-amber-950/40 dark:text-amber-400"
    : "border-transparent bg-muted text-muted-foreground";
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full border px-2 py-0.5 text-[10px] uppercase tracking-wider ${className}`}
    >
      {isSpecial ? "Special" : "Regular"}
    </span>
  );
};
